import axios from 'axios';

const API_URL = process.env.VUE_APP_API_URL;
const SPACE_ID = process.env.VUE_APP_SPACE_ID;
const PAGE_ENTITY_ID = process.env.VUE_APP_PAGE_ENTITY_ID;
const ARTICLE_ENTITY_ID = process.env.VUE_APP_ARTICLE_ENTITY_ID;
const JOB_ENTITY_ID = process.env.VUE_APP_JOB_ENTITY_ID;
const INFO_ENTITY_ID = process.env.VUE_APP_INFO_ENTITY_ID;

const getPage = contentId => axios.get(`${API_URL}/spaces/${SPACE_ID}/entities/${PAGE_ENTITY_ID}/contents/${contentId}`)
  .then(response => response.data);

const getArticles = () => axios.get(`${API_URL}/spaces/${SPACE_ID}/entities/${ARTICLE_ENTITY_ID}/contents`)
  .then(response => response.data);

const getArticle = contentId => axios.get(`${API_URL}/spaces/${SPACE_ID}/entities/${ARTICLE_ENTITY_ID}/contents/${contentId}`)
  .then(response => response.data);

const getJobs = () => axios.get(`${API_URL}/spaces/${SPACE_ID}/entities/${JOB_ENTITY_ID}/contents`)
  .then(response => response.data);

const getInfo = contentId => axios.get(`${API_URL}/spaces/${SPACE_ID}/entities/${INFO_ENTITY_ID}/contents/${contentId}`)
  .then(response => response.data);

const getImage = source => `${API_URL}/spaces/${source.spaceId}/media/${source.linkId}`;

const api = {};
api.getPage = getPage;
api.getArticles = getArticles;
api.getArticle = getArticle;
api.getJobs = getJobs;
api.getInfo = getInfo;
api.getImage = getImage;

export default api;
